import { render, staticRenderFns } from "./OMItems.vue?vue&type=template&id=2a1e4d02&"
import script from "./OMItems.vue?vue&type=script&lang=js&"
export * from "./OMItems.vue?vue&type=script&lang=js&"
import style0 from "./OMItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports